import { render, staticRenderFns } from "./MiniappshaichaVisionScreeningUser.vue?vue&type=template&id=5b0221d3&scoped=true&"
import script from "./MiniappshaichaVisionScreeningUser.vue?vue&type=script&lang=js&"
export * from "./MiniappshaichaVisionScreeningUser.vue?vue&type=script&lang=js&"
import style0 from "./MiniappshaichaVisionScreeningUser.vue?vue&type=style&index=0&id=5b0221d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0221d3",
  null
  
)

export default component.exports